var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tinymce-editor',{attrs:{"id":'editor' + _vm.idEditor,"api-key":_vm.$tinymceApi,"value":_vm.vModelName,"plugins":_vm.Plugins,"toolbar":_vm.Toolbar,"init":_vm.Init},on:{"input":function($event){return _vm.$emit('update:vModelName', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }